<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

const { name, mobile } = useDisplay()
const appStore = useAppStore()
const authStore = useAuthStore()

const hideDevBar = ref(false)
</script>

<template>
  <VSystemBar
    v-if="!hideDevBar"
    class="dev-bar"
    color="primary"
  >
    <span class="dev-bar__title dev-bar__title--uppercase">[{{ appStore.config.APP_ENV }}]</span>
    <span class="mx-2">-</span>
    <VTooltip location="top">
      <template #activator="{ props }">
        <span
          v-bind="props"
          class="dev-bar__title"
        >[{{ name }}]</span>
      </template>
      <div>Vuetify Breakpoint Name: <span class="font-weight-bold">{{ name }}</span></div>
    </VTooltip>
    <span class="mx-2">-</span>
    <VTooltip location="top">
      <template #activator="{ props }">
        <VIcon
          v-bind="props"
          class="dev-bar__icon dev-bar__icon--active"
          :icon="mobile ? 'mdi-cellphone' : 'mdi-monitor'"
        />
      </template>
      <div>mobile: <span class="font-weight-bold">{{ mobile }}</span></div>
    </VTooltip>

    <VSpacer />

    <VTooltip location="top">
      <template #activator="{ props }">
        <VIcon
          v-bind="props"
          class="dev-bar__icon mr-2"
          :class="authStore.is_shadowing ? 'dev-bar__icon--active' : ''"
          icon="mdi-ghost"
        />
      </template>
      <div>is_shadowing: <span class="font-weight-bold">{{ authStore.is_shadowing }}</span></div>
    </VTooltip>

    <VTooltip location="top">
      <template #activator="{ props }">
        <VIcon
          class="dev-bar__icon dev-bar__icon--btn ms-2"
          icon="mdi-close"
          v-bind="props"
          @click="hideDevBar = true"
        />
      </template>
      <span>Hide Dev Bar for current session</span>
    </VTooltip>
  </VSystemBar>
</template>

<style lang="scss">
.dev-bar {
  bottom: 0 !important;
  top: unset !important;
  left: unset !important;
  width: 100% !important;
  z-index: 10001 !important;

  &__title {
    font-weight: bold;

    &--uppercase {
      text-transform: uppercase;
    }
  }

  &__icon {
    opacity: 0.3 !important;
    color: #000;
    transition: all 0.3s ease-in-out;

    &:hover {
      opacity: 1 !important;
    }

    &--btn {
      cursor: pointer;
    }

    &--active {
      color: #fff;
      opacity: 1 !important;
    }
  }
}
</style>
